import "./App.css";
import Home from "./pages/home/Home";

const App = () => {
	return (
		<div className='app'>
			<Home />
		</div>
	);
};

export default App;
